import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Lock, BookOpenCheck, Flame } from "lucide-react";

const values = [
  { icon: ShieldCheck, k: "Integrity", d: "Honest counsel, including when the answer is difficult." },
  { icon: Lock, k: "Confidentiality", d: "Client matters are held in strict confidence, without exception." },
  { icon: BookOpenCheck, k: "Preparation", d: "Every brief is read, every provision verified, every argument tested." },
  { icon: Flame, k: "Dedication", d: "A single-minded commitment to the client's cause, within the bounds of the law." },
];

export default function Values() {
  return (
    <section className="py-24 md:py-40 bg-[#0B0B0B]" data-testid="values-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-24">
        <div className="mb-16 md:mb-20 grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <h2 className="font-serif-display text-4xl md:text-6xl leading-[1.05] text-white/95">Professional<br/><span className="italic text-[#C8A45D]/90">values.</span></h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 text-white/55 font-body text-base md:text-lg leading-relaxed self-end">
            In accordance with the Bar Council of India Rules, which do not permit testimonials, the following sets out the standards by which the chamber conducts its practice.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/5">
          {values.map((v, i) => {
            const Icon = v.icon;
            return (
              <motion.div
                key={v.k}
                initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.8, delay: i * 0.08 }}
                className="bg-[#0B0B0B] p-10 md:p-14 flex gap-8 items-start"
                data-testid={`value-${v.k.toLowerCase()}`}
              >
                <Icon className="text-[#C8A45D] shrink-0" strokeWidth={1.1} size={36} />
                <div>
                  <div className="font-cinzel text-[9px] tracking-[0.35em] text-white/40 mb-2">0{i+1}</div>
                  <h3 className="font-serif-display text-3xl md:text-4xl text-white mb-3 leading-none">{v.k}</h3>
                  <p className="text-white/55 font-body">{v.d}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
